import { Component } from '@verndale/core';

class Header extends Component {
  setupDefaults() {
    this.dom = {
      searchTrigger: this.el.querySelector<HTMLElement>('.header__navigation__search-trigger'),
      searchPannel: this.el.querySelector<HTMLElement>('.header__search-pannel'),
      searchForm: this.el.querySelector<HTMLElement>('.header__search-pannel__form'),
      searchInput: this.el.querySelector<HTMLInputElement>('.header__search-pannel__input'),

      menuTrigger: this.el.querySelector<HTMLElement>('.header__navigation__menu-trigger'),
      menuPannel: this.el.querySelector<HTMLElement>('.header__menu-pannel'),
      menuContent: this.el.querySelector<HTMLElement>('.header__menu-pannel__list'),
    };
  }

  addListeners() {
    if (this.dom.searchTrigger) {
      (this.dom.searchTrigger as HTMLElement).addEventListener('click', this.handleSearchTriggerClick.bind(this));
    }
    
    (this.dom.searchForm as HTMLElement).addEventListener('submit', this.handleSearchSubmit.bind(this));

    if(this.dom.menuTrigger){
      (this.dom.menuTrigger as HTMLElement).addEventListener('click', this.handleMenuTriggerClick.bind(this));
    }
  }

  handleSearchTriggerClick() {
    if (this.el.classList.contains('header--search-active')) {
      this.closeSearch();
      return;
    }

    this.openSearch();
  }

  openSearch() {
    const searchPannel = this.dom.searchPannel as HTMLElement;
    const searchForm = this.dom.searchForm as HTMLElement;
    const searchInput = this.dom.searchInput as HTMLInputElement;

    const pannelHeight = searchForm.offsetHeight;

    searchPannel.style.blockSize = `${pannelHeight}px`;

    this.el.classList.add('header--search-active');
    searchPannel.setAttribute('aria-expanded', 'true');
    searchInput.focus();
  }

  closeSearch() {
    const searchPannel = this.dom.searchPannel as HTMLElement;

    searchPannel.style.blockSize = '0';

    searchPannel.setAttribute('aria-expanded', 'true');
    this.el.classList.remove('header--search-active');
  }

  handleSearchSubmit(ev: Event) {
    ev.preventDefault();

    const redirectPath = (this.dom.searchForm as HTMLElement).dataset.redirectPath || '/search.asp#stq={KEYWORD}&stp=1';
    const value = (this.dom.searchInput as HTMLInputElement).value;

    window.location.href = redirectPath.replace('{KEYWORD}', value);
  }

  handleMenuTriggerClick() {
    if (this.el.classList.contains('header--menu-active')) {
      this.closeMenu();
      return;
    }

    this.openMenu();
  }

  openMenu() {
    const menuPannel = this.dom.menuPannel as HTMLElement;
    const menuContent = this.dom.menuContent as HTMLElement;

    const pannelHeight = menuContent.offsetHeight;

    menuPannel.style.blockSize = `${pannelHeight}px`;

    this.el.classList.add('header--menu-active');
    menuPannel.setAttribute('aria-expanded', 'true');
  }

  closeMenu() {
    const menuPannel = this.dom.menuPannel as HTMLElement;

    menuPannel.style.blockSize = '0';

    menuPannel.setAttribute('aria-expanded', 'true');
    this.el.classList.remove('header--menu-active');
  }
}

export default Header;
